/**
 * 「どれか1つでも成功したら」というPromiseを作って返す
 */
export default async function promiseAny<T>(...promises: Promise<T>[]): Promise<T> {
  // Promise.all の resolve と reject を入れ替えることで、最初に成功した結果が catch に届く
  try {
    const reasons: any[] = await Promise.all<any>(promises.map((p) => {
      // resolve と reject を入れ替える
      return p.then(value => Promise.reject(value), reason => Promise.resolve(reason))
    }))
    // 全て失敗したらここに到達する
    return Promise.reject(reasons[0])
  } catch (firstValue) {
    // 1つでも成功したらここに到達する
    return Promise.resolve(<T>firstValue)
  }
}
